import {
    IonPage, IonContent, IonAlert, IonInput
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import {accountAppeal} from "./Service";
import {uploadImage} from "../../../../utils/uploadPic";
import {getQueryVariable, isPhoneNumber} from "../../../../utils/commonFunction";
import {addressInit} from "../../../../utils/address";
import cookieUtil from "../../../../utils/cookieUtil";


class AccountAppeal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phone: '',
            phoneTip: 0,
            code: '',
            codeTip: null,
            agreementTip: true,
            scriptLoaded: false,
            showTipModal: false,
            getCodeMsg: "获取验证码",
            showNoticeTip: false,
            djs: '',
            account: '',
            token: null,
            isAgree: false,
            selectedIdImagesOne: [],
            selectedIdImagesTwo: [],
            realImageOne: null,
            realImageTwo: null,
            step: 1,
            isPicUpload: false,
            content: '',
            orderIds: '',
            realName: '',
            appealTypeArr: [
                {id: 2, label: '重置保险箱密码'},
                {id: 3, label: '解除绑定手机'},
                {id: 17, label: '解除绑定微信'},
                {id: 6, label: '其他问题'}],
            appealType: 2,
        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[0-9]{6}$/)


    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")})
        }
        if (cookieUtil.has("userInfo")) {
            let userInfoJson = JSON.parse(cookieUtil.get("userInfo"))
            //console.log(userInfoJson);
            this.setState({account: userInfoJson.userGameId})
        }
        // 兼容公众号个人中心--帐号申诉跳转至该页面
        let userGameId = getQueryVariable('userGameId');
        if (userGameId !== null && userGameId !== '' && userGameId !== '0') {
            this.setState({account: userGameId})
        }
    }

    setPhone = (e) => {
        this.setState({phone: e, phoneTip: 0})
    }
    checkPhone = () => {
        const {phone} = this.state;
        let phoneTip = 0;
        if (!this.regPhone.test(phone)) {
            phoneTip = 1;
        }
        this.setState({
            phoneTip: phoneTip,
        })

    };

    setAppealType = (e) => {
        this.setState({appealType: e})
    }

    setCode = (e) => {
        let codeTip = 0;
        if (this.regCode.test(e)) {
            codeTip = 1
        }

        this.setState({
            code: e,
            codeTip: codeTip
        })
    }

    showNotice = () => {
        const {showNoticeTip} = this.state;
        this.setState({
            showNoticeTip: !showNoticeTip
        })
    }

    nextTip = () => {
        const {account, isAgree} = this.state;

        if (!isAgree) {
            this.setState({
                isShowTip: true,
                showTipMsg: "请仔细阅读并同意《账号申诉服务协议》。"
            })
            return;
        }

        if (account === '') {
            this.setState({isShowTip: true, showTipMsg: '请输入正确的账号/游戏ID'})
            return;
        }

        this.setState({
            step: 2,
            showNoticeTip: false
        })
        setTimeout(function () {
            addressInit('selectProv', 'selectCity', 'selectIstrict')
        }, 300);
    }

    returnPage = () => {
        const {isPicUpload} = this.state;
        if (isPicUpload) {
            this.setState({isPicUpload: false})
        }
        setTimeout(function () {
            addressInit('selectProv', 'selectCity', 'selectIstrict')
        }, 300);
    }

    submitAppeal = () => {
        const {
            phone,
            token,
            account,
            isAgree,
            realImageOne,
            realImageTwo,
            content,
            realName,
            orderIds,
            gameName,
            appealType,
        } = this.state;

        if (!isAgree) {
            this.setState({
                isShowTip: true,
                showTipMsg: "请仔细阅读并同意《账号申诉服务协议》。"
            })
        }

        if (account === '') {
            this.setState({isShowTip: true, showTipMsg: '请输入正确的账号/游戏ID'})
            return;
        }

        /*if (appealType != 6 && orderIds === '') {
            this.setState({isShowTip: true, showTipMsg: '请输入订单号'})
            return;
        }*/

        if (realName === '') {
            this.setState({isShowTip: true, showTipMsg: '请填写账号实名的姓名'})
            return;
        }

        if (realImageOne == null || realImageTwo == null) {
            this.setState({isShowTip: true, showTipMsg: '请上传身份证的正、反面'})
            return;
        }

        if (!isPhoneNumber(phone)) {
            this.setState({isShowTip: true, showTipMsg: '请输入正确的手机号码！'})
            return;
        }

        if (content === '' || content.length < 10) {
            this.setState({isShowTip: true, showTipMsg: '申诉理由，至少输入10个汉字'})
            return;
        }

        const seachprovValue = document.getElementById('selectProv').value;
        const seachcityValue = document.getElementById('selectCity').value;
        const seachdistrictValue = document.getElementById('selectIstrict').value;
        const oftenLoginArea = seachprovValue + seachcityValue + seachdistrictValue;

        const params = {
            'access_token': token,
            'appealType': appealType,
            'accounts': account,
            'cardFrontUrl': realImageOne,
            'cardReverseUrl': realImageTwo,
            'phone': phone,
            'appealReason': content,
            'realName': realName,
            'idCard': '',
            'qqNumber': '',
            'nearPlayGame': gameName,
            'orderIds': orderIds,
            'address': oftenLoginArea,
        };
        //console.log(params)
        accountAppeal(params).then(ret => {
            if (ret.code === '10000') {
                this.setState({
                    isShowTip: true,
                    showTipMsg: '申诉成功'
                })
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                })
            }
        }).catch(err => {
            console.log(err);
        });
    }

    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }

    /**
     * 图片上传
     * @param type  1身份证正面图 2身份证反面
     * @param event
     * @returns {Promise<void>}
     */
    handleFileInputChange = async (type, event) => {
        const {
            selectedIdImagesOne,
            selectedIdImagesTwo,
            realImageOne,
            realImageTwo,
        } = this.state;

        const fileList = event.target.files;
        //console.log(fileList);
        let images = [];

        switch (type) {
            case 1:
                if (selectedIdImagesOne.length + fileList.length > 1) {
                    this.setState({isShowTip: true, showTipMsg: '最多上传1张图片,请重新选择！'})
                    return;
                }
                images = selectedIdImagesOne;
                break;
            case 2:
                if (selectedIdImagesTwo.length + fileList.length > 1) {
                    this.setState({isShowTip: true, showTipMsg: '最多上传1张图片,请重新选择！'})
                    return;
                }
                images = selectedIdImagesTwo;
                break;
        }


        let isJpgOrPng = true;
        let isLt2M = true;
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            //console.log(file)
            isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                this.setState({isShowTip: true, showTipMsg: '只能上传JPG/PNG格式的图片'})
                return;
            }
            isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.setState({isShowTip: true, showTipMsg: '上传图片不能大于10MB'})
                return;
            }
        }

        let realUrls = [];

        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            const reader = new FileReader();
            const params = {
                file: file,
                path: 'pc/accountRefund'
            }
            const imageUrl = await uploadImage(params);
            if (imageUrl === "" || imageUrl === null) {
                this.setState({isShowTip: true, showTipMsg: '图片上传失败'})
                return;
            }
            realUrls = imageUrl

            reader.onload = (event) => {
                images.push(event.target.result);
                if (i === fileList.length - 1) {
                    switch (type) {
                        case 1:
                            this.setState({selectedIdImagesOne: images, realImageOne: realUrls})
                            break;
                        case 2:
                            this.setState({selectedIdImagesTwo: images, realImageTwo: realUrls})
                            break;
                    }
                }
            };
            await reader.readAsDataURL(file);
        }
    }

    /**
     * 上图图片按钮触发
     * @param idx
     */
    uploadBtnLoad = (idx) => {
        const uploadInput = document.getElementById('upload_' + idx);
        uploadInput.click();
    }

    /**
     * 删除图片
     * @param index
     */
    handleImageDelete = (index, type) => {
        const {
            selectedIdImagesOne,
            selectedIdImagesTwo,
            realImageOne,
            realImageTwo,
        } = this.state;

        let images = [];
        let realImages = [];
        switch (type) {
            case 1:
                images = [...selectedIdImagesOne];
                realImages = [...realImageOne];
                images.splice(index, 1);
                realImages.splice(index, 1);
                this.setState({selectedIdImagesOne: images, realImageOne: realImages})
                break;
            case 2:
                images = [...selectedIdImagesTwo];
                realImages = [...realImageTwo];
                images.splice(index, 1);
                realImages.splice(index, 1);
                this.setState({selectedIdImagesTwo: images, realImageTwo: realImages})
                break;
        }


    };

    /**
     * 图片上传页面展示
     * @param type
     */
    uploadPage = (type) => {
        this.setState({
            isPicUpload: true,
            picType: type
        })
    }

    render() {

        const {
            phone,
            showNoticeTip,
            isAgree,
            isPicUpload,
            picType,
            selectedIdImagesOne,
            selectedIdImagesTwo,
            step,
            content,
            gameName,
            orderIds,
            showGrey,
            showTis,
            appealType,
        } = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    {isPicUpload ?
                        <div className="sut_cont bggray">
                            <div className="phone_top pr">
                                <a className="xya_return" onClick={() => this.returnPage()}>
                                    <img src={require("../../../images/member/refund/return_icon.png")}/>
                                </a>
                                {picType === 1 && <div className="top_title">身份证正面(国徽)</div>}
                                {picType === 2 && <div className="top_title">身份证反面(人像)</div>}
                            </div>
                            <div className="sut_box">
                                {picType === 1 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <a className="sut_link pr" onClick={() => this.uploadBtnLoad('one')}>
                                                <span className="img_icon pa">
                                                    <img src={require("../../../images/member/refund/pic_icon.png")}/>
                                                </span>
                                                <p className="nub_tex pa">{selectedIdImagesOne.length}/1</p>
                                            </a>

                                        </div>
                                        {selectedIdImagesOne.length > 0 && selectedIdImagesOne.map((image, index) => (
                                            <div key={index} className="sut_list">
                                                <a onClick={() => this.handleImageDelete(index, 1)}
                                                   className="sut_link pr">
                                                    <span className="slt_img pa"><img src={image} alt=""/></span>
                                                    <p className="nub_tex pa">{index + 1}/1</p>
                                                    <i className="gray_bg pa"></i>
                                                    <em className="close_icon pa">
                                                        <img
                                                            src={require("../../../images/member/refund/close_icon.png")}/>
                                                    </em>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                }
                                {picType === 2 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <a className="sut_link pr" onClick={() => this.uploadBtnLoad('two')}>
                                                <span className="img_icon pa">
                                                    <img src={require("../../../images/member/refund/pic_icon.png")}/>
                                                </span>
                                                <p className="nub_tex pa">{selectedIdImagesTwo.length}/1</p>
                                            </a>

                                        </div>
                                        {selectedIdImagesTwo.length > 0 && selectedIdImagesTwo.map((image, index) => (
                                            <div key={index} className="sut_list">
                                                <a onClick={() => this.handleImageDelete(index, 2)}
                                                   className="sut_link pr">
                                                    <span className="slt_img pa"><img src={image} alt=""/></span>
                                                    <p className="nub_tex pa">{index + 1}/1</p>
                                                    <i className="gray_bg pa"></i>
                                                    <em className="close_icon pa">
                                                        <img
                                                            src={require("../../../images/member/refund/close_icon.png")}/>
                                                    </em>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                }
                                <input id="upload_one" type="file" onChange={e => this.handleFileInputChange(1, e)}
                                       className="file dn" accept="image/*"/>
                                <input id="upload_two" type="file" onChange={e => this.handleFileInputChange(2, e)}
                                       className="file dn" accept="image/*"/>

                            </div>
                        </div> :
                        <div className="sut_cont bggray">
                            <div className={"phone_top pr border-bottom-e6"}>
                                <div className="top_title">账号申诉</div>
                            </div>
                            {step === 1 ? <div className="cont_kf">
                                <div className="point_tex"><p>每个账号一年仅限申请一次解绑手机和微信服务。</p></div>
                                <div className="radio_cont_kf clearfix">
                                    {this.state.appealTypeArr.map(option => (
                                        <label className="w355 mb20 radio-label">
                                            <input type="radio"
                                                   onChange={() => this.setAppealType(option.id)}
                                                   value={option.id}
                                                   checked={appealType === option.id ? true : ""}
                                                   name="type" className="radio"/>{option.label}
                                        </label>
                                    ))}
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w246 ml30">游戏账号或ID</span>
                                    <input type="text" className="input-tex5"
                                           placeholder="第三方账号请填写游戏ID " value={this.state.account}
                                           onChange={e => this.setState({account: e.target.value})}/>
                                </div>
                                <div className="Agreed clearfix agreement" style={{marginTop: '2%'}}>
                                    {/*<div className="choose"></div>*/}
                                    <div onClick={() => this.setState({isAgree: !isAgree})}
                                         className={isAgree ? "on" : "agreed"}></div>
                                    <div className="choose_tex"><span className="textGrey9">阅读</span>
                                        <a className="textBlue"
                                           href="https://wfw.fuyuncc.com/pc/accountAppeal/appealService.html">账号申诉服务协议</a>
                                    </div>
                                </div>
                                <a className="btn_kf" onClick={this.nextTip}>确认</a>
                                <div className="cont_tex">
                                    <div className="cont_tex_title" onClick={this.showNotice}>常见问题</div>
                                    <div className="cont_tex_title"
                                         onClick={() => window.location = "/phone/appealProgress"}>申诉进度查询
                                    </div>
                                    <p className={showNoticeTip ? "hidden_tex" : "dn"}>
                                        <span className="textBlack">申诉的处理时限？</span><br/>
                                        1.账号解绑手机、微信等申诉（1-3个工作日内处理）；<br/>
                                        2.重置账号密码类申诉24小时内处理（不包含法定节假日，如有特殊情况延至5个工作日内处理）。<br/>
                                        <span className="textBlack">如何查询申诉结果？</span><br/>
                                        申诉结果请前往：信息进度中心-申诉进度查询。</p>
                                </div>
                            </div> : <div className="cont_kf">
                                <div className="point_tex"><p>请上传账号实名认证的证件信息，并附上当日手写的申诉日期<a
                                    className="textBlue"
                                    onClick={() => this.setState({showGrey: true, showTis: true})}>（查看示例）</a></p>
                                </div>

                                <div className="phone_identity clearfix">
                                    <span className="w246 ml30">近期体验平台游戏</span>
                                    <input type="text" className="input-tex4"
                                           value={gameName}
                                           onChange={e => {
                                               this.setState({gameName: e.target.value})
                                           }}
                                           placeholder="如：龙珠捕鱼"/>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w246 ml30">充值订单号</span>
                                    <input type="text" className="input-tex4"
                                           value={orderIds}
                                           onChange={e => {
                                               this.setState({orderIds: e.target.value})
                                           }}
                                           placeholder="如：2013xxx456（17位）"/>
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w246 ml30">* 账号实名</span>
                                    <IonInput type="text" className="input-tex4"
                                              value={this.state.realName}
                                              placeholder="请填写账号实名"
                                              onIonChange={e => this.setState({realName: e.detail.value})}/>
                                </div>
                                <div className="clearfix pr phone_identity" onClick={() => this.uploadPage(1)}>
                                    <span className="w280 ml30">* 账号实名证件正面照</span>
                                    <a className="upload_icon1">
                                        <img src={require("../../../images/member/refund/jt_icon.png")}/></a>
                                    {selectedIdImagesOne.length > 0 && <p className="upload_tex1 pa">已上传</p>}
                                </div>
                                <div className="clearfix pr phone_identity" onClick={() => this.uploadPage(2)}>
                                    <span className="w280 ml30">* 账号实名证件反面照</span>
                                    <a className="upload_icon1">
                                        <img src={require("../../../images/member/refund/jt_icon.png")}/></a>
                                    {selectedIdImagesTwo.length > 0 && <p className="upload_tex1 pa">已上传</p>}
                                </div>
                                <div className="phone_identity clearfix">
                                    <span className="w135 ml30">* 联系手机</span>
                                    <input type="text" className="input-tex4"
                                           value={phone}
                                           onChange={e => {
                                               this.setState({phone: e.target.value})
                                           }}
                                           placeholder="填写正确手机号"/>
                                </div>
                                <div className={"clearfix phone_identity"}>
                                    <span className="w280">常登录的地区</span>
                                    <div className="login_area">
                                        <center>
                                            <select id="selectProv" className="select_input1 w120 mr10"
                                                    name="seachprov"></select>
                                            <select id="selectCity" className="select_input1 w120 mr10"
                                                    name="homecity"></select>
                                            <select id="selectIstrict" className="select_input1 w120"
                                                    name="homecity"></select>
                                            <div className="clear"></div>
                                        </center>
                                    </div>
                                </div>
                                <div className="clearfix pr phone_identity bbn">
                                    <span className="w246 ml30">* 申诉理由</span>
                                    <textarea name="textarea" id="textarea"
                                              value={content}
                                              onChange={e => {
                                                  this.setState({content: e.target.value})
                                              }}
                                              className="textarea"
                                              placeholder={"提示：请尽可能描述您所发现的问题（如操作过程发生异常的情况等），至少输入10个汉字。"}> </textarea>
                                </div>
                                <br></br>
                                <a className="btn_kf" onClick={this.submitAppeal}>确认</a>
                                <div className="cont_tex">
                                    <div className="cont_tex_title" onClick={this.showNotice}>信息安全说明</div>
                                    <p className={showNoticeTip ? "hidden_tex" : "dn"}>
                                        <span className="textBlack">申诉的处理时限？</span><br/>
                                        1、以上提供信息仅供用户本人处理账号问题使用，不作其他用途。<br/>
                                        2、平台对用户上传身份证相关证件照片统一做水印及加密处理。</p>
                                </div>
                            </div>
                            }
                            {/*<!-------------------------灰色透明层--------------------->*/}
                            <div className={showGrey ? "greybackground" : 'dn'}></div>
                            {/*<!-------------------------账号申诉身份证示例图 tc--------------------->*/}
                            <div className={showTis ? "tc02" : 'dn'}>
                                <div className="tc_bg">
                                    <a className="close"
                                       onClick={() => this.setState({showGrey: false, showTis: false})}>关闭</a>
                                    <div className="tc_cont pr">
                                        <div className="tc_title">账号申诉身份证示意图</div>
                                        <div className="sfz_img"><img
                                            src={require("../../../images/member/kefu/phone/sfz_img.jpg")}/></div>
                                        <div className="sfz_ts_tex"><img
                                            src={require("../../../images/member/kefu/phone/sxr_img.jpg")}/></div>
                                        <div className="sfz_tex">
                                            <p className="textRed">1 .
                                                需本人身份证证件，相关信息清晰且确保任意手指按压在身份证左侧面，否则无效；</p>
                                            <p className="textRed">2 . 需本人手写申诉申请当天日期，且保证相关信息清晰，否则无效
                                                。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(AccountAppeal);
